export const subscriptionGiftNoteMaxLength = 280;
